import { React, useState, useEffect } from "react";
import styled from "styled-components";
import { Layout, Table, Button, PageHeader } from "antd";
import {
  RightLayoutContainer,
  OtherPages,
  PageTitleComp,
} from "../styledElements";
import logoCompany from "../../Assets/Images/logo.svg";
import Iconmoon from "../../Components/IconsFiles/icon";
import * as htmlToImage from "html-to-image";
//import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
//import { jsPDF } from "jspdf";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { paperMachineListData } from "../../Services/machineServices";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import { getCompanyDetails } from "../../Services/companyServices";
const PrintData = styled.div`
  padding: 0px;
  margin: 40px auto;
  background-color: #fff;
  width: 845px;
`;

const ExportHeader = styled.div`
  background-color: #faf9f8;
  padding: 10px 15px;
  .file-header {
    display: flex;
    justify-content: space-between;
  }
  .file-header-logo {
    width: 130px;
    display: flex;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .client-name {
    width: 25%;
  }
  .client-name h4 {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    margin: 0px;
  }
  .client-name h6 {
    font-style: italic;
    color: #605e5c;
    font-size: 10px;
    margin: 0px;
    text-transform: capitalize;
  }
  .client-data {
    display: flex;
    > div {
      width: 50%;
      label {
        color: #000;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
      span {
        color: #605e5c;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
    }
  }
`;

const ExportTable = styled.div`
  table {
    width: 100%;
  }
  thead th {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  td {
    border-bottom: 1px solid #000;
  }

  th,
  td {
    text-align: left;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 90px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
  .sub-text {
    font-size: 10px;
    color: #605e5c;
    font-style: italic;
  }
  .spec {
    font-size: 13px;
  }
  .priority {
    background: #fdf0ef;
  }
`;

function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}

addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const ExportProductionDetailsPdf = (props) => {
  const [showLoader, setLoader] = useState(false);
  const [company, setCompany] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const [records, setRecords] = useState(location?.state?.records ? location?.state?.records : []);
  const [fileNameForPDF, setFileNameForPDF] = useState(location?.state?.fileNameForPDF);
  const currentDate = new Date();
  const today = (currentDate.getDate() + " " + currentDate.toLocaleString("default", { month: "long" }) + "," +  currentDate.getFullYear());
  const recordStatus = location?.state?.body?.status?.status?.charAt(0).toUpperCase() + location?.state?.body?.status?.status?.substring(1,location?.state?.body?.status?.status?.length);
  useEffect(() => {
    setCompanyDetails();
  }, []);

  const setCompanyDetails = () => {
    getCompanyDetails()
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => console.log("Error", error));
  };

  const exportHandler = () => {
    const input = document.getElementById("export-content");
    html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
      (canvas) => {
        const image = { type: "jpeg", quality: 0.98 };
        const margin = [0.5, 0.5];
        const filename = "myfile.pdf";

        var imgWidth = 8.5;
        var pageHeight = 11;

        var innerPageWidth = imgWidth - margin[0] * 2;
        var innerPageHeight = pageHeight - margin[1] * 2;

        // Calculate the number of pages.
        var pxFullHeight = canvas.height;
        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        var nPages = Math.ceil(pxFullHeight / pxPageHeight);

        // Define pageHeight separately so it can be trimmed on the final page.
        var pageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        var pageCanvas = document.createElement("canvas");
        var pageCtx = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;

        // Initialize the PDF.
        var pdf = new jsPDF("p", "in", [8.5, 11]);

        for (var page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            pageHeight =
              (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }

          // Display the page.
          var w = pageCanvas.width;
          var h = pageCanvas.height;
          pageCtx.fillStyle = "white";
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          // debugger;
          var imgData = pageCanvas.toDataURL(
            "image/" + image.type,
            image.quality
          );
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            pageHeight
          );
        }

        pdf.save(fileNameForPDF+".pdf");
      }
    );
  };

  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() =>
            navigate("../production-detail/export-production-details", {
              state: {
                body: location?.state?.body,
                rootPage: location?.state?.rootPage,
                fileName: location?.state?.fileNameForPDF,
                productionData: records,
                exportProductionDetail: location?.state?.exportProductionDetail,
                returnKey: true
            },
            })
          }
          title= {`${recordStatus} reel production preview`}
          extra={[
            <Button
              key="1"
              className="themeBtn"
              onClick={() => exportHandler()}
            >
              <Iconmoon icon="download" size={17} color="#FFFFFF" />
              Download {recordStatus} Reel Production Records
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <PrintData id="export-content">
        <OtherPages>
          <Layout
            style={{
              backgroundColor: "#ffffff",
            }}
          >
            <div>
              <ExportHeader>
                <div className="file-header">
                  <div className="file-header-logo">
                    <img src={logoCompany} alt="Kaiznn" />
                  </div>
                  <div className="client-name">
                    {company && <h4>{company.business_name}</h4>}
                    <h6>{recordStatus} Reel Production Records</h6>
                    <div className="client-data">
                      <div>
                        <label>Number of records</label>
                        <span>{records?.length}</span>
                      </div>
                      <div>
                        <label>Date:</label>
                        <span>{today}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ExportHeader>
              <ExportTable>
                <table>
                  <thead>
                    <tr>
                      <th>REEL NUMBER</th>
                      <th>ORDER/STOCK DETAILS</th>
                      <th>JOB CARD DETAILS</th>
                      <th>SIZE</th>
                      <th>FINISHING DETAILS</th>
                      <th>REEL WEIGHT</th>
                      <th>CLOSING DATE</th>
                      <th>PRODUCT DETAILS</th>
                      <th>REMARKS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records?.map((prodData) => {
                      return (
                        <tr className={prodData.priorityOrder ? "priority" : ""}>
                          <td>
                            <div className="main-text">
                              <p className="p-ton f-10">{prodData.reelNumber}</p>
                            </div>
                          </td>
                          <td>
                            <p className="p-ton f-10">PO NO.: {prodData.po}</p>
                            <p className="p-ton f-10">GROUP NO.: {prodData.groupNo}</p>
                            <p className="p-ton f-10">
                              ORDER/STOCK NO.: {prodData.orderNumber}
                            </p>
                            {prodData.priorityOrder && (
                              <p className="sub-text">Priority Order</p>
                            )}
                            <p className="sub-text">
                              Delivery Date:
                            </p>
                            <p className="sub-text">
                               {prodData.deliveryDate}
                            </p>
                          </td>
                          <td>
                            <p className="p-ton f-10">
                              JOB CARD NO.: {prodData.jobCardNumber}
                            </p>
                            <p className="p-ton f-10">
                              PARENT REEL/SET NO.: {prodData.parentReelNumber}
                            </p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{prodData.reelSize}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">
                              CORE OD: {prodData.coreOD}
                            </p>
                            <p className="p-ton f-10">
                              REEL OD: {prodData.reelOD}
                            </p>
                            <p className="sub-text">
                              Finishing Shift: {prodData.finishingShift}
                            </p>
                            <p className="sub-text">
                              Finishing Date:{" "}
                              {prodData.finishingDate}
                            </p>
                          </td>
                          <td>
                            <p className="p-ton f-10">
                              {prodData.reelWeight}
                            </p>
                          </td>
                          <td>
                            <p className="p-ton f-10">
                              {prodData.closingDate}
                            </p>
                          </td>
                          <td>
                            <p className="sub-text"></p>
                            <p className="sub-text">{prodData.productCode} - {prodData.productName} </p>
                            <p className="sub-text spec">{prodData.prodSpecification}</p>
                          </td>
                          <td>
                            <p className="remark f-10">{prodData.remarks}</p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </ExportTable>
            </div>
          </Layout>
        </OtherPages>
      </PrintData>
    </RightLayoutContainer>
  );
};
export default ExportProductionDetailsPdf;
